<template>
  <div class="arco-empty">
    <slot name="image">
      <div class="empty-image" :style="imgSize">
        <img alt="" :src="imgSrc || $aliYunOss + 'blank-2.png'" />
      </div>
    </slot>
    <slot name="description">
      <div class="empty-description">{{ $t(displayDescription, descriptionKey) }}</div>
    </slot>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  imgSrc: {
    type: String,
    default: ''
  },
  description: {
    type: String,
    default: 'common.noData'
  },
  descriptionKey: {
    type: Object,
    default: ()=>{}
  },
  width: {
    type: Number,
    default: 0
  },
  height: {
    type: Number,
    default: 0
  },
  // 加载中时缺省图下方文案为「数据加载中」，否则为 description（默认暂无数据）
  loading: {
    type: Boolean,
    default: false
  }
})

const displayDescription = computed(() => (props.loading ? 'common.dataLoading' : props.description))

const imgSize = computed(() => {
  const obg = {}
  if (props.width || props.height) {
    if (props.width) {
      obg.width = props.width + 'px'
    }
    if (props.height) {
      obg.height = props.height + 'px'
    }
  }
  return obg
})
</script>

<style scoped lang="scss">
.empty-image {
  @apply w-150 my-0 mx-auto;
  img {
    @apply max-w-full max-h-full;
  }
}

.empty-description {
  @apply text-center text-text-color-2 mt-16;
}
</style>
